import { URLS } from '@/config/urls';

/**
 * Returns a full url to an article
 * @param slug
 * @returns
 */
export const getGamingGuideUrl = (slug: string) => `${URLS.GAMING_GUIDES}/${slug}`;
